import React from 'react'
import { useStyle } from "./Style";
import { Grid } from '@mui/material';

const ClaimSummary = (props) => {
  const classes = useStyle();

  console.log('ClaimSummary props', props.claimInitiationPayload)
  console.log('ClaimSummary props', props.claimSummaryData)

  if (!props.claimSummaryData) return (
    <>
      <Grid container spacing={2} className={classes.headingclaim}>
        <Grid item xs={12} sm={12} md={12}>
          <h4>Claim Details</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <p>nothing found yet</p>
        </Grid>
      </Grid>
    </>
  )
  return (
    <>
      <Grid container spacing={2} className={classes.headingclaim}>
        <Grid item xs={12} sm={12} md={12}>
          <h4>Claim Summary</h4>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>

          {
            props.hasHospitalBenefit ? (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Admission Date</th>
                    <th>Discharge Date</th>
                    <th>Number Of Days In Hospital</th>
                    <th>Hospital Attended</th>
                    <th>Inpatient Number</th>
                    <th>Cause Of Hospitilization</th>
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.additional_details.admission_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.discharge_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.number_of_days_in_hospital || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.hospital_attended || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.inpatient_number || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.cause_of_hospitilization || "N/A"}</td>
                  </tr>
                </table>


              </div>
            </>) : props.hasDeathBenefit ? (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Date Of Death</th>
                    <th>Cause of Death</th>
          
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.additional_details.date_of_death || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.cause_of_death || "N/A" }</td>
                  </tr>
                </table>


              </div>
            
            
            </>) : (<>

              <div className={classes.claimDetailsWrapper}>
                <table>
                  <tr>
                    <th>Policy  Number</th>
                    <th>Admission Date</th>
                    <th>Discharge Date</th>
                    <th>Number of Days in Hospital</th>
                    <th>Hospital Attended</th>
                    <th>Inpatient Number</th>
                    <th>Type of Cancer</th>
                  </tr>
                  <tr >
                    <td>{props.claimSummaryData.policy_number}</td>
                    <td>{props.claimSummaryData.additional_details.admission_date || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.discharge_date || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.number_of_days_in_hospital || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.hospital_attended || "N/A" }</td>
                    <td>{props.claimSummaryData.additional_details.inpatient_number || "N/A"}</td>
                    <td>{props.claimSummaryData.additional_details.type_of_cancer || "N/A" }</td>
                  </tr>
                </table>


              </div>
            
            
            
            </>)
          }


        </Grid>
      </Grid>
    </>
  )
}

export default ClaimSummary